// ** MUI Imports
import { Adsense } from '@ctrl/react-adsense'
import { Button, Stack } from '@mui/material'
import Grid from '@mui/material/Grid'
import { deleteCookie, getCookie } from 'cookies-next'
import { GetServerSidePropsContext } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import useLocalStorage from 'src/@core/hooks/useLocalStorage'

import BookApi from 'src/@core/utils/api/book-api'
import { BookData } from 'src/@core/utils/types'
import CardBook from 'src/views/book/CardBook'

type SearchPageProps = {
  bookList: BookData[]
}
const BookDiscoveryPage = ({ bookList }: SearchPageProps) => {
  const router = useRouter()
  const [, setUser] = useLocalStorage('user')
  const pageNumber = parseInt(router.query.pageNumber as string)
  const [query, setQuery] = useState(router.query.query)

  useEffect(() => {
    const user = getCookie('user')
    if (user) {
      setUser(JSON.parse(user as string))
      deleteCookie('user')
    }
  }, [setUser])

  useEffect(() => {
    setQuery(router.query.query)
  }, [router])

  return (
    <>
      <Head>
        <title key={'title'}>{`Search book`}</title>
      </Head>
      <Grid container spacing={6}>
        {bookList.map((book, idx) => (
          <>
            {idx > 0 && idx % 4 === 0 && <Grid item key={idx} xs={12}>
              <Adsense client={process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_ID as string} slot={process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_SLOT as string} responsive={'true'} />
            </Grid>}
            <Grid item key={idx} xs={12} sm={6}>
              <CardBook action='add' book={book} />
            </Grid>
          </>
        ))}
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stack direction={'row'} spacing={2}>
            {pageNumber > 1 && (
              <Button
                variant={'outlined'}
                href={`/book/search/?query=${query}&pageNumber=${pageNumber - 1}`}
                onClick={e => {
                  e.preventDefault()
                  router.push(`/book/search/?query=${query}&pageNumber=${pageNumber - 1}`)
                }}
              >
                previous page
              </Button>
            )}
            {bookList.length > 0 && <Button
              variant={'outlined'}
              href={`/book/search/?query=${query}&pageNumber=${pageNumber + 1}`}
              onClick={e => {
                e.preventDefault()
                router.push(`/book/search/?query=${query}&pageNumber=${pageNumber + 1}`)
              }}
            >
              next page
            </Button>}
          </Stack>
        </Grid>
      </Grid>
    </>
  )
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const { query, pageNumber } = context.query
  const bookList = await BookApi.searchBooks(query, parseInt(pageNumber as string))

  return { props: { bookList } }
}

export default BookDiscoveryPage
